import axios from 'axios';
import _ from 'lodash';
import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';

import {typesAddressdet} from '../svtypes/addressdet'


let headers = {'Content-Type': 'application/json'}
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }


export const svLoadAddressdetBegin = () => dispatch => {
    dispatch({
        type:'GET_ADDRESSDET_BEGIN'
        
    })
}


export const geLoadAddressdetSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_ADDRESSDET_SUCCESS',
        payload: data
    })
}

export const getLoadAddressdetError = (e) =>dispatch => {
    console.log(e)
    dispatch({
        type:'GET_ADDRESSDET_ERROR',
        payload:e
    })
}




/*
export function loadAddressDetOld(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadAddressdetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
        const body = {
            "id": (nameQParam? nameQParam:3)
           }
          
        
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if( r.data ){
                    const ob = r.data
                    if(ob.addressId && (ob.addressId > 0)){
                        ob.id = ob.addressId;
                    }

                    const comData = { my_data_addressdet:  ob }

                    dispatch(geLoadAddressdetSuccess(comData))
                }
                else {
                    const comData = { my_data_addressdet: {
                        "id": -1,
                        "fname": "LucasError",
                        "lname": "GlenError",
                        "email": "lucas123@yahoo.com",
                        "address": "12 scotland av",
                        "city": "Albany",
                        "state": "New York",
                        "zip": "12110",
                        "country": "USA",
                        "isdcode": "+1",
                        "phone": "5121234358"
                    }}
                    dispatch(getLoadAddressdetError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadAddressdetError(e))
        )
    }
}
*/

export function loadAddressDet_org(nameQParam,hdr, relUrl){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadAddressdetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       let body = {
            "id": (nameQParam? nameQParam:3)
           }
         // body.id = 97
        const url = relUrl ? `${SV_SOJ_ORCMOCK_ADDRESS}/${relUrl}` :`${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail` 
        const svhdr = hdr ? hdr: headers 
        axios.post(url, body, {headers:svhdr})
        .then(
            r => {
                let  m= null
                if( r.data ){
                    const ob = r.data
                    if(ob.status && ob.status !=200){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getLoadAddressdetError(eeb))
                    }else{
                        if(ob.addressId && (ob.addressId > 0)){
                            ob.id = ob.addressId;
                        }

                        const {dateOfBirth} = ob
                        let s = dateOfBirth ? dateOfBirth:  '1995-08-25T00:00:00.000+0000'
                        let hasTime =  s.indexOf('T') > -1 ? true :false
                        
                       
                        if(hasTime == "Y"){
                                  
                            s=   ob["dateOfBirth"]
                              m =s.substring(0,10) 
                              ob["dateOfBirth"] = s
                           
                        }
                        
    
                        const comData = { my_data_addressdet:  ob }
    
                        dispatch(geLoadAddressdetSuccess(comData))
                    }
                    
                }
                else {
                    const comData = { my_data_addressdet: {
                        "id": -1,
                        "fname": "LucasError",
                        "lname": "GlenError",
                        "email": "lucas123@yahoo.com",
                        "address": "12 scotland av",
                        "city": "Albany",
                        "state": "New York",
                        "zip": "12110",
                        "country": "USA",
                        "isdcode": "+1",
                        "phone": "5121234358"
                    }}
                    console.log('errr********', comData)
                    dispatch(getLoadAddressdetError(comData))
                }
            }
        ).catch(
            e=>{
                console.log('errr**REAL******')
                console.log(e)
                dispatch(getLoadAddressdetError(e)) }
        )
    }
}


export function createResetFlagsAddressDet_svbakj15 (){
    console.log('%%%%%%%%%%%%%%%sv++++RESET createResetFlagsAddressDet For _doc swith sae key ')

    return dispatch =>{
        let body = {"reset":"yes"}
        dispatch(svLoadAddressdetReset(body))
    }
}
export function loadAddressDetSecure_org(nameQParam, svtv){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadAddressdetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       let body = {
            "id": (nameQParam? nameQParam:3)
           }
          //body.id = 97
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetailSecure` 
        const authtoken = `Bearer ${svtv}`
        const svheaders = { 'Authorization': authtoken,
        'Content-Type': 'application/json' };
     
        axios.post(url, body, {headers:svheaders})
        .then(
            r => {
                if( r.data ){
                    const ob = r.data
                    if(ob.status && ob.status !=200){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getLoadAddressdetError(eeb))
                    }else{
                        if(ob.addressId && (ob.addressId > 0)){
                            ob.id = ob.addressId;
                        }
    
                        const comData = { my_data_addressdet:  ob }
    
                        dispatch(geLoadAddressdetSuccess(comData))
                    }
                    
                }
                else {
                    const comData = { my_data_addressdet: {
                        "id": -1,
                        "fname": "LucasError",
                        "lname": "GlenError",
                        "email": "lucas123@yahoo.com",
                        "address": "12 scotland av",
                        "city": "Albany",
                        "state": "New York",
                        "zip": "12110",
                        "country": "USA",
                        "isdcode": "+1",
                        "phone": "5121234358"
                    }}
                    console.log('errr********', comData)
                    dispatch(getLoadAddressdetError(comData))
                }
            }
        ).catch(
            e=>{
                console.log('errr**REAL******')
                console.log(e)
                dispatch(getLoadAddressdetError(e)) }
        )
    }
}
export function addAddressNow(rqValues){


    
    console.log('%%%%%%%%%%%%%%%sv++++REST API For createOrModifyAddressNow from Microservices DB swith sae key :' )
   
   
    return dispatch => {
        dispatch(svcreateOrModifyAddressBegin())
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/createOrModifyAddressNow`
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                let comData = {
                    "my_data_address_confirmation" : {

                        "status":"OK",
                        "addressId":"UU12345",
                        "saveDate":"Jan 3027"
                    }
                }
                if(r.data){
                   
                   
                    comData.my_data_address_confirmation = r.data
                    

                   
                    dispatch(getCreateOrModifyAddressSuccess(comData))
                }
                else {
                    comData.my_data_address_confirmation.status = "FAILED"
                    comData.my_data_address_confirmation.addressId = "XXX"
                    comData.my_data_address_confirmation.saveDate = "Jan 3027"

                    dispatch(getCreateOrModifyAddressSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getCreateOrModifyAddressError(e))
        )
    }

}



export function addAddressNowSecure(rqValues ,svtv){


    
    console.log('%%%%%%%%%%%%%%%sv++++REST API For createOrModifyAddressNow from Microservices DB swith sae key :' )
   
   
    return dispatch => {
        dispatch(svcreateOrModifyAddressBegin())
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/createOrModifyAddressNowSecure`
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
          const authtoken = `Bearer ${svtv}`
          const svheaders = { 'Authorization': authtoken,
          'Content-Type': 'application/json' };
       axios.post(url, rqValues, {headers:svheaders})
        .then(
            r => {
                console.log('sv********response headers start')
                console.log(r.headers)
                console.log('sv********response headers ebd')
                let comData = {
                    "my_data_address_confirmation" : {

                        "status":"OK",
                        "addressId":"UU12345",
                        "saveDate":"Jan 3027"
                    }
                }
                let crudsuccessob ={
                    "timestamp": "2015-08-23T02:27:18.038+0000",
                    "status": 200,
                    "error": "",
                    "message": "Create Done ",
                    "path": "/kk/svaddressDetailPost"
                }
                if(r.data){
                   
                   
                    comData.my_data_address_confirmation = r.data
                    
                    comData.crudsuccessob = crudsuccessob
                   
                    dispatch(getCreateOrModifyAddressSuccess(comData))
                }
                else {
                    comData.crudsuccessob = crudsuccessob
                    comData.my_data_address_confirmation.status = "FAILED"
                    comData.my_data_address_confirmation.addressId = "XXX"
                    comData.my_data_address_confirmation.saveDate = "Jan 3027"

                    dispatch(getCreateOrModifyAddressSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getCreateOrModifyAddressError(e))
        )
    }

}

export const svcreateOrModifyAddressBegin = () => dispatch => {
    dispatch({
        type:typesAddressdet.GET_SAVEADDRESS_BEGIN
        
    })
}


export const getCreateOrModifyAddressError = (e) =>dispatch => {
    dispatch({
        type:typesAddressdet.GET_SAVEADDRESS_ERROR,
        payload:e
    })
}


export const getCreateOrModifyAddressSuccess = (data) => dispatch => {
    dispatch({
        type: typesAddressdet.GET_SAVEADDRESS_SUCCESS,
        payload: data
    })
}

export const svLoadAddressdetReset = (data) => dispatch => {
    dispatch({
        type: "RESET_SAVEADDRESS_INIT",
        payload: data
    })
}

export function loadAddressDet(nameQParam,hdr, relUrl){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadAddressdetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       let body = {
            "id": (nameQParam? nameQParam:3)
           }
         // body.id = 97
         /*sbj15 start*/
         const bodyGeoNewList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
         if(nameQParam && (nameQParam > 0)){
            let customerId = nameQParam
           
            bodyGeoNewList.docId.push("" + customerId)
        }else{
            console.log('Nov19review customerId + error by UI')
        }
         const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geographyMyReservation`
                
         /*svj15 end*/
        const url = relUrl ? `${SV_SOJ_ORCMOCK_ADDRESS}/${relUrl}` :`${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail` 
        const svhdr = hdr ? hdr: headers 
        axios.all([
            axios.post(url, body, {headers:svhdr}),
            axios.post(urlGeoList, bodyGeoNewList, {headers:headers}),
        ], {
            timeout: 7000
        })
        .then(
            axios.spread((r,r5)=>{
               
                    if( r.data ){
                        const ob = r.data
                        if(ob.status && ob.status !=200){
                            let eeb = {
    
                            }
                            eeb.errob = ob
                            dispatch(getLoadAddressdetError(eeb))
                        }else{
                            if(ob.addressId && (ob.addressId > 0)){
                                ob.id = ob.addressId;
                            }
                             //svr5 start
                         let my_data_geo = null
                         console.log('svj25 my_data_geo*********')
                         console.log(r5.data )
                         if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                          my_data_geo = r5.data
                         
                         }
                         console.log(comData )
                         //svr5 end
                            const comData = { my_data_addressdet:  ob, my_data_geo:my_data_geo }
        
                            dispatch(geLoadAddressdetSuccess(comData))
                        }

                        
                        
                    }
                    else {
                        const comData = { my_data_addressdet: {
                            "id": -1,
                            "fname": "LucasError",
                            "lname": "GlenError",
                            "email": "lucas123@yahoo.com",
                            "address": "12 scotland av",
                            "city": "Albany",
                            "state": "New York",
                            "zip": "12110",
                            "country": "USA",
                            "isdcode": "+1",
                            "phone": "5121234358"
                        }}
                        console.log('errr********', comData)
                        dispatch(getLoadAddressdetError(comData))
                    }
                

            })
            ).catch(
                e=>{
                    console.log('errr**REAL******')
                    console.log(e)
                    dispatch(getLoadAddressdetError(e)) }
            )
            //svj15 en
       
    }
}


export function loadAddressDetSecure(nameQParam, svtv){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadAddressdetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       let body = {
            "id": (nameQParam? nameQParam:3)
           }
          //body.id = 97
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetailSecure` 
        const authtoken = `Bearer ${svtv}`
        const svheaders = { 'Authorization': authtoken,
        'Content-Type': 'application/json' };
     
      //svj15start
      const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
      const bodyGeoEmptyIdList = {"docId":["USA"],"hsetname":"HotelInvDB"}

     
        axios.all([
            axios.post(url, body, {headers:svheaders}),
            axios.post(urlGeoList, bodyGeoEmptyIdList, {headers:headers}),
        ], {
            timeout: 7000
        })
        .then(
            axios.spread((r,r5)=>{
               
                    if( r.data ){
                            const ob = r.data
                            if(ob.status && ob.status !=200){
                                let eeb = {
        
                                }
                                eeb.errob = ob
                                dispatch(getLoadAddressdetError(eeb))
                            }else{
                                if(ob.addressId && (ob.addressId > 0)){
                                    ob.id = ob.addressId;
                                }
                                //svr5 start
                                let my_data_geo = null
                                console.log('svj25 my_data_geo*********')
                                console.log(r5.data )
                                if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                                  my_data_geo = r5.data
                                
                                }
                                
                            
                              
                                //svr5 end
                                const comData = { my_data_addressdet:  ob, my_data_geo:my_data_geo }
                                console.log(comData )
                                dispatch(geLoadAddressdetSuccess(comData))
                                }

                        
                        
                    
                            }else {
                        const comData = { my_data_addressdet: {
                            "id": -1,
                            "fname": "LucasError",
                            "lname": "GlenError",
                            "email": "lucas123@yahoo.com",
                            "address": "12 scotland av",
                            "city": "Albany",
                            "state": "New York",
                            "zip": "12110",
                            "country": "USA",
                            "isdcode": "+1",
                            "phone": "5121234358"
                        }}
                        console.log('errr********', comData)
                        dispatch(getLoadAddressdetError(comData))
                    }
                

            })
            ).catch(
                e=>{
                    console.log('errr**REAL******')
                    console.log(e)
                    dispatch(getLoadAddressdetError(e)) }
            )
      //svj15end
    }
}
/*
const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
                    const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
                 
*/
export function createResetFlagsAddressDet(){
    console.log('%%%%%%%%%%%%%%%sv++++RESET createResetFlagsAddressDet For _doc swith sae key ')
    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********0')
                
    return dispatch =>{
        let my_data_geo = null
        let body = {"reset":"yes",my_data_geo:my_data_geo }
        //svstart
        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
                    const bodyGeoEmptyIdList = {"docId":["USA"],"hsetname":"HotelInvDB"}
     
        axios.post(urlGeoList, bodyGeoEmptyIdList, {headers:headers})
        .then(
            r => {
                console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********1a')
                   
                if( r.data ){
                    //svaiiisd_geoPost start
                    
                    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********2a')
                    console.log(r.data )
                    if(  r.data.countryTypes && r.data.countryTypes.length>0){
                     my_data_geo = r.data
                     body.my_data_geo = my_data_geo
                    }
                    console.log(body )
                    //svaiiisd_geoPost end

                    dispatch(svLoadAddressdetReset(body))
                }else{
                    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********2b')
                   
                    dispatch(svLoadAddressdetReset(body))
                }
            }
        ).catch(
                e=>{
                    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********1b')
                   
                    dispatch(getCreateOrModifyAddressError(e))
                }
            )
        //svend
       
    }
}

